export default {
  SET_STATUS(state, status) {
    state.requestStatus = status;
  },

  SET_IS_FETCHING(state, isFetching) {
    state.isFetching = isFetching;
  },

  SET_RESPONSE(state, data) {
    state.data = data;
  },

  SET_PUBLIC_KEY_DATA(state, publicKeyData) {
    state.publicKeyData = publicKeyData;
  },

  SET_OTP_DATA(state, data) {
    state.otpData = data;
  },

  SET_PAYLOAD(state, data) {
    state.savedPayload = data;
  },
  SET_REGISTER_MOBILE_DATA(state, data) {
    state.regMobileData = data;
  },

  SET_MY_INFO_DETAILS(state, data) {
    state.myInfoDetails = data;
  },

  SET_IS_MOBILE_NUMBER_UPDATED(state, data) {
    state.isMobileNumberUpdated = data;
  },

  SET_CURRENT_STEP(state, data) {
    state.currentStep = data;
  },
  DELETE_DATA(state) {
    state.data = {};
  },
  SET_STEPPER_MAXLENGTH(state, data) {
    state.stepperMaxLength = data;
  },
  SET_MEMBER_ID(state, data) {
    state.memberId = data;
  },

  SET_EXISTING_MEMBER_ID(state, data) {
    state.existingMemberId = data;
  },
  SET_SIGNUP_MOBILE(state, data) {
    state.signUpMobile = data;
  },
};
